import Echo from 'laravel-echo';

export function createSocketConnection() {
    if (!window.Echo) {
        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: process.env.REACT_APP_WEBSOCKET_KEY,
            cluster: process.env.REACT_APP_WEBSOCKET_CLUSTER,
            wsHost: process.env.REACT_APP_WEBSOCKET_URL,
            forceTLS: false,
            wsPort: process.env.REACT_APP_WEBSOCKET_PORT,
            wssPort: process.env.REACT_APP_WEBSOCKET_PORT,
            encrypted: false,
            transports: ['websocket', 'polling', 'flashsocket'],
            enabledTransports: ['ws', 'wss'],
        });
    }
}

// socketListener.js
export function listenToChannel({ channel, event, callback }) {
  if (!window?.Echo || !channel || !event || !callback) return () => {};

  const echoChannel = window.Echo.channel(channel);

  echoChannel.listen(event, callback);

  return () => {
    window.Echo.leaveChannel(channel);
  };
}

